export const SITE_URL = "https://thequantumminds.in";
export const SITE_NAME = "The Quantum Minds";
export const OG_IMAGE = `${SITE_URL}/og-image.jpg`;

type MetaTag = Record<string, string>;

export interface SeoInput {
  title: string;
  description: string;
  /** Absolute path of this page, e.g. "/about". Omit for non-indexable pages. */
  path?: string;
  type?: "website" | "article";
  noindex?: boolean;
}

/** Builds a duplicate-free meta list plus a self-referencing canonical link. */
export function seo({ title, description, path, type = "website", noindex }: SeoInput): {
  meta: MetaTag[];
  links: MetaTag[];
} {
  const url = path ? `${SITE_URL}${path}` : undefined;
  const meta: MetaTag[] = [
    { title },
    { name: "description", content: description },
    { property: "og:title", content: title },
    { property: "og:description", content: description },
    { property: "og:type", content: type },
    { property: "og:site_name", content: SITE_NAME },
    { property: "og:locale", content: "en_IN" },
    { property: "og:image", content: OG_IMAGE },
    { property: "og:image:width", content: "1200" },
    { property: "og:image:height", content: "630" },
    { property: "og:image:alt", content: `${SITE_NAME} — JEE & NEET study platform` },
    { name: "twitter:card", content: "summary_large_image" },
    { name: "twitter:title", content: title },
    { name: "twitter:description", content: description },
    { name: "twitter:image", content: OG_IMAGE },
    { name: "twitter:image:alt", content: `${SITE_NAME} — JEE & NEET study platform` },
  ];
  if (url) meta.push({ property: "og:url", content: url });
  meta.push({
    name: "robots",
    content: noindex ? "noindex, nofollow" : "index, follow, max-image-preview:large",
  });

  const links: MetaTag[] = url && !noindex ? [{ rel: "canonical", href: url }] : [];
  return { meta, links };
}

/** BreadcrumbList JSON-LD script entry for a leaf route. */
export function breadcrumbScript(trail: { name: string; path: string }[]) {
  return {
    type: "application/ld+json",
    children: JSON.stringify({
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      itemListElement: trail.map((t, i) => ({
        "@type": "ListItem",
        position: i + 1,
        name: t.name,
        item: `${SITE_URL}${t.path}`,
      })),
    }),
  };
}